import { render } from "./Catalogue.vue?vue&type=template&id=56265bed&scoped=true"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=56265bed&scoped=true&lang=css"

import exportComponent from "/home/oliver/Development/auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56265bed"]])

export default __exports__